import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactFormDialog from '../components/ContactFormDialog';

const TermsConditions = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <Header onOpenContactForm={() => setIsContactFormOpen(true)} />

      <div className="pt-32 pb-16 bg-[#09090B]">
        <div className="max-w-7xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center text-[#3B82F6] hover:text-white mb-6 transition-colors text-sm font-semibold">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
          </Link>
          <h1 className="font-heading text-5xl sm:text-6xl font-semibold tracking-tight leading-none text-white">
            Terms & <span className="font-medium text-[#3B82F6]">Conditions</span>
          </h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg prose-invert max-w-none">
          <p className="text-sm text-[#A1A1AA] mb-8">Last updated: February 2026</p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">1. Acceptance of Terms</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            By accessing and using the services of Trademark Protection For Logos, located at 18952 MacArthur Blvd Suite 100, Irvine, CA 92612, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">2. Services</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            Trademark Protection For Logos provides logo trademark registration, trademark search, trademark filing, and ongoing trademark protection and monitoring services. Our services include preparation and filing of applications with the USPTO.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">3. Service Fees</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            Our service fees are separate from government filing fees. Government fees (such as USPTO filing fees) are paid directly to the respective agencies and are non-refundable. Our service packages and pricing are listed on our website and may be updated periodically.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">4. Client Responsibilities</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            Clients are responsible for providing accurate and complete information for all filings. You represent that all information provided to us is true, accurate, and not misleading. Any delays caused by incomplete or inaccurate information are the client's responsibility.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">5. No Guarantee of Registration</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            While we provide professional services to maximize the chances of successful registration, we cannot guarantee that any trademark application will be approved. The USPTO makes final decisions on all applications independently.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">6. Limitation of Liability</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            Trademark Protection For Logos shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount you paid for our services.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">7. Intellectual Property</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            All content on our website, including text, graphics, logos, and images, is the property of Trademark Protection For Logos and is protected by US intellectual property laws. You may not reproduce, distribute, or create derivative works without our written permission.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">8. Governing Law</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            These terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Orange County, California.
          </p>

          <h2 className="font-heading text-2xl font-semibold text-white mt-10 mb-4">9. Contact Information</h2>
          <p className="text-[#A1A1AA] leading-relaxed mb-6">
            For questions about these Terms and Conditions, contact us at:<br />
            <strong>Trademark Protection For Logos</strong><br />
            18952 MacArthur Blvd Suite 100, Irvine, CA 92612<br />
            Email: info@trademarkprotectionforlogos.com<br />
            Phone: (800) 555-1234
          </p>
        </div>
      </div>

      <Footer onOpenContactForm={() => setIsContactFormOpen(true)} />
      <ContactFormDialog isOpen={isContactFormOpen} onClose={() => setIsContactFormOpen(false)} />
    </div>
  );
};

export default TermsConditions;
